<div class="company-container">
  <div class="top-part">
    <div class="top-part-wrap">
      <div class="goals-navbar d-flex me-5 mb-2">
        <h5 class="table-title">Print Formats</h5>
      </div>
      <div class="second-section d-flex align-items-center justify-content-end">
        <span
          matTooltip="Delete Record(s)"
          matTooltipPosition="above"
          *ngIf="false"
        >
          <button
            class="btn filter-btn ms-2"
            data-toggle="modal"
            data-target="#deleteDataModal"
            aria-label="OpenDeleteModal"
            (click)="openConfirmPopup(selectedLabelIDs)"
          >
            <img
              style="width: 22px"
              src="../../../assets/Pricingscreen/delete.svg"
            />
          </button>
        </span>
        <div class="searchbar d-flex ms-2" style="width: 60%">
          <img class="search me-2" src="../../../assets/icons/searchbar.svg" />
          <input
            type="text"
            placeholder="Search"
            [(ngModel)]="labelsInput"
            (keyup)="getSearchResult($event)"
          />
        </div>
        <ng-template [ngxPermissionsOnly]="['Label:Create']" *ngIf="false">
          <div
            class="create-btn ms-2 c-pt"
            data-bs-target="#addGradeModalToggle"
            data-bs-toggle="modal"
            (click)="clearForm()"
          >
            <img src="../../../../../assets/icons/whitePlus.svg" />
            Add New
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <section class="intro">
    <div class="table-container">
      <table class="table category-table table-condensed" id="mainParent">
        <thead class="main-head sticky-top">
          <tr>
            <th scope="col" style="align-items: center; text-transform: none">
              <div class="form-check d-flex align-items-center">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input"
                  id="flexCheckDefault1"
                  type="checkbox"
                  [checked]="headerCheckboxSelected"
                  (change)="toggleAllCheckboxes()"
                />

                <label for="flexCheckDefault">Name</label>
              </div>
            </th>
            <th scope="col" style="text-transform: none">Description</th>
            <th scope="col" style="text-transform: none">Printer Name</th>
            <th scope="col" style="text-transform: none">Status</th>
            <th scope="col" style="text-transform: none">Created On</th>
            <th scope="col" style="text-transform: none">Updated On</th>
            <th scope="col" style="text-transform: none">Updated By</th>
            <th scope="col" style="text-align: center; text-transform: none">
              Actions
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let label of labels"
            [ngClass]="{
              'highlighted-row': label.id === selectedRowIndex
            }"
          >
            <td class="d-flex g-2" style="align-items: center">
              <div class="form-check">
                <input
                  style="height: 20px; width: 20px; margin-right: 10px"
                  class="form-check-input"
                  type="checkbox"
                  [value]="label.id"
                  id="flexCheckDefault1"
                  [checked]="headerCheckboxSelected"
                  [(ngModel)]="label.isSelected"
                  (change)="handleCheckboxChange($event, label)"
                />
              </div>
              <label for="" style="font-size: 14px; font-weight: 700">{{
                label.name
              }}</label>
            </td>
            <td>{{ label.description }}</td>
            <td>{{ label.printerName }}</td>
            <td>{{ Status[label.status] }}</td>
            <td>{{ label.createdAt | date: "MM/dd/yyyy" }}</td>
            <td>{{ label.lastModifiedAt | date: "MM/dd/yyyy" }}</td>
            <td>{{ label.createdBy }}</td>
            <td style="text-align: center">
              <div class="btn-group dropleft" style="gap: 10px">
                <span matTooltip="View Print Format" matTooltipPosition="above">
                  <button
                    type="button"
                    style="margin-top: 4px"
                    class="action-drop d-flex align-items-center"
                    (click)="showPreview(label.id)"
                    data-bs-target="#exampleModalCenter"
                    data-bs-toggle="modal"
                  >
                    <i
                      style="color: #676767"
                      style="font-size: 1.2rem"
                      class="fa-regular fa-eye"
                    ></i>
                  </button>
                </span>
                <ng-template
                  [ngxPermissionsOnly]="['Label:Update']"
                  *ngIf="false"
                >
                  <span matTooltip="Edit Record" matTooltipPosition="above">
                    <button
                      style="height: 20px; width: 20px; margin-right: 10px"
                      type="button"
                      class="action-drop me-2"
                      data-bs-target="#addGradeModalToggle"
                      data-bs-toggle="modal"
                      (click)="getLabelById(label.id)"
                    >
                      <i
                        ><img
                          style="width: 25px; height: 25px"
                          src="../../../assets/Pricingscreen/update.svg"
                      /></i>
                    </button>
                  </span>
                </ng-template>
                <ng-template
                  [ngxPermissionsOnly]="['Label:Delete']"
                  *ngIf="false"
                >
                  <span matTooltip="Delete Record" matTooltipPosition="above">
                    <button
                      style="height: 20px; width: 20px"
                      type="button"
                      class="action-drop"
                      data-toggle="modal"
                      data-backdrop="static"
                      data-target="#deleteDataModal"
                      (click)="openConfirmPopup(label.id)"
                    >
                      <i
                        ><img
                          style="width: 25px; height: 25px"
                          src="../../../assets/Pricingscreen/delete.svg"
                      /></i>
                    </button>
                  </span>
                </ng-template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        *ngIf="labels.length == 0"
        class="nodata"
        style="
          height: 56vh;
          width: 100%;
          display: flex;
          margin: auto;
          align-items: center;
          margin: auto;
          border: none;
        "
      >
        <p
          style="
            margin: auto;
            border: transparent !important;
            font-size: 2rem;
            color: #a4a4a4;
          "
        >
          No Data Available
        </p>
      </div>
    </div>
  </section>
</div>

<!--Boostrap modal for add new grade-->
<div
  class="modal fade"
  id="addGradeModalToggle"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="custom-modal-dialog modal-dialog modal-dialog-centered">
    <form #labelform="ngForm">
      <div class="modal-content">
        <div class="custom-modal-body modal-body" style="width: 40vw">
          <div class="modal-body-wraapper">
            <h3 class="mb-4" style="padding-left: 15px">{{ frmText }}</h3>
            <div class="selector">
              <div class="custom-label">
                <label for="gradeColorInput" class="form-label"
                  >Print Format <span class="text-danger">*</span>
                </label>
                <p>:</p>
              </div>
              <input
                type="text"
                class="form-control"
                name="formatTypeDesr"
                placeholder="Enter Label Name"
                [(ngModel)]="label.name"
                required
                #formatTypeDesr="ngModel"
              />
            </div>
            <div class="selector">
              <div class="custom-label">
                <label for="gradeDescriptionInput" class="form-label"
                  >Print Format Description <span class="text-danger">*</span>
                </label>
                <p>:</p>
              </div>
              <input
                type="text"
                class="form-control"
                name="formatTypeCd"
                placeholder="Enter Label Description"
                [(ngModel)]="label.description"
                required
                #formatTypeCd="ngModel"
              />
            </div>
            <div class="selector">
              <div class="custom-label">
                <label for="gradeDescriptionInput" class="form-label"
                  >Type</label
                >
                <p>:</p>
              </div>
              <select
                name="labelEntityType"
                class="custome-select"
                [(ngModel)]="label.labelEntityType"
              >
                <option [ngValue]="0" disabled>Select Type</option>
                <option
                  *ngFor="let entityType of labelEntityTypes"
                  [ngValue]="entityType.id"
                >
                  {{ entityType.name }}
                </option>
              </select>
            </div>
            <div class="selector">
              <div class="custom-label">
                <label for="gradeDescriptionInput" class="form-label"
                  >Select Printer</label
                >
                <p>:</p>
              </div>
              <select
                name="labelType"
                class="custome-select"
                [(ngModel)]="label.printerType"
              >
                <option [ngValue]="0" disabled>Select Printer</option>
                <option
                  *ngFor="let printer of printersType"
                  [ngValue]="printer.id"
                >
                  {{ printer.name }}
                </option>
              </select>
            </div>
            <div class="selector" style="align-items: baseline">
              <div class="custom-label">
                <label for="gradeDescriptionInput" class="form-label"
                  >ZPL Code</label
                >
                <p>:</p>
              </div>
              <textarea
                class="form-control"
                id="gradeDescriptionInput"
                name="gradeDescr"
                placeholder="Enter Print Format ZPL Code"
                [(ngModel)]="label.zplCode"
                rows="10"
                style="width: 65%"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="custom-modal-footer modal-footer">
          <div class="btns d-flex justify-content-end" style="width: 60%">
            <button
              class="btn modal-btn me-2"
              data-bs-dismiss="modal"
              aria-label="Close"
              (click)="highlightedRow(null)"
            >
              Cancel
            </button>
            <button
              class="btn modal-btn add-btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              (click)="createLabel(label)"
              [hidden]="!hideUpdateBtn"
              [disabled]="labelform.invalid"
            >
              Add Print Format
            </button>
            <button
              class="btn modal-btn add-btn"
              data-bs-dismiss="modal"
              aria-label="Close"
              (click)="createLabel(label)"
              [hidden]="hideUpdateBtn"
              [disabled]="labelform.invalid"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!--Boostrap modal for deleting Grade -->
<div
  class="modal fade"
  id="deleteDataModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="deleteButtonClickedWithSelection">
        <h5>Delete</h5>
      </div>
      <div class="modal-header" *ngIf="deleteButtonClickedWithoutSelection">
        <h5>No Record Selected !</h5>
      </div>

      <div class="modal-body" *ngIf="deleteButtonClickedWithSelection">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to delete the Selected Records?<br />
            Or you can make Selected Records inactive.
          </p>
          <p class="fw-bold mt-3">
            Once deleted, all the saved data will get deleted.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="deleteButtonClickedWithoutSelection">
        <div class="modal-body-wraapper">
          <p>Please select one or more records to delete.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button
          class="btn modal-btn me-2"
          data-dismiss="modal"
          aria-label="Close"
          #modalConfirmCloseButton
          (click)="highlightedRow(null)"
        >
          Close
        </button>
        <button
          button
          class="btn modal-btn"
          data-dismiss="modal"
          aria-label="Close"
          *ngIf="deleteButtonClickedWithSelection"
          style="background-color: rgb(23, 95, 145); color: white"
          (click)="deleteGrade(deleteParameter)"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="exampleModalCenter"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content image-modal">
      <div class="modal-header justify-content-between align-items-center">
        <h4 style="margin: 0">Preview</h4>
        <button
          type="button"
          class="close-tag"
          data-bs-dismiss="modal"
          aria-label="Close"
          #closeBtn
          style="all: unset; font-size: 2rem"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <img
          *ngIf="labelImg && labelImg.toString().length > 0"
          [src]="labelImg"
          class="previewImg"
        />
        <p
          *ngIf="!labelImg || labelImg.toString().length === 0"
          class="invalidMsg"
        >
          Invalid ZPL Code
        </p>
      </div>
    </div>
  </div>
</div>
